import { LoaderActions, LoaderActionTypes } from './loader.actions';

export interface LoaderState {
    active: number;
    actionsInProgress: any[];
}

const initialState: LoaderState = {
    active: 0,
    actionsInProgress: []
};

export function loaderReducer(state = initialState, action: LoaderActions): LoaderState {
    switch (action.type) {
        case LoaderActionTypes.ShowSpinner: {

            const isActionAlreadyInProgress = state.actionsInProgress
                .filter((currentAction: any) =>
                    currentAction === action.payload.type)
                .length;
            // If the action in already in progress and is registered
            // we don't modify the state
            if (isActionAlreadyInProgress) {
                return state;
            }
            // Adding the action type in our actionsInProgress array
            const newActionsInProgress = [
                ...state.actionsInProgress,
                action.payload.type
            ];

            return {
                active: newActionsInProgress.length,
                actionsInProgress: newActionsInProgress
            };
        }
        case LoaderActionTypes.HideSpinner: {
            // We remove trigger action from actionsInProgress array
            const newActionsInProgress = action.payload.triggerAction ?
                state.actionsInProgress
                    .filter((currentAction: any) =>
                        currentAction !== action.payload.triggerAction) :
                state.actionsInProgress;

            return {
                actionsInProgress: newActionsInProgress,
                active: state.active > 0 ?
                    newActionsInProgress.length : 0
            };
        }
        case LoaderActionTypes.ForceHideSpinner: {
            // We remove trigger action from actionsInProgress array
            const newActionsInProgress = [];

            return {
                actionsInProgress: newActionsInProgress,
                active: 0
            };
        }
        default:
            return state;
    }
}
